import { z } from "zod";

const digest = z.string().regex(/^[a-f0-9]{64}$/);
const identifier = z.string().min(1).max(260);

/** Synchronized installation preferences MUST NOT contain device capability grants. */
export const ArcadePluginInstallStatesSchema = z.record(identifier, z.object({
  pluginId: identifier,
  source: z.enum(["builtin", "catalog"]),
  status: z.enum(["available", "installed", "disabled", "error"]),
  installedVersion: z.string().min(1).max(128).optional(),
  manifestDigest: digest,
  grantRevision: z.number().int().positive(),
  enabled: z.boolean(),
  installedAt: z.string().datetime({ offset: true }).optional(),
  updatedAt: z.string().datetime({ offset: true }).optional(),
  failureReason: z.string().max(4096).optional(),
}).strict()).superRefine((states, context) => {
  for (const [key, state] of Object.entries(states)) {
    if (key !== state.pluginId)
      context.addIssue({ code: "custom", message: "Installation identity mismatch", path: [key] });
  }
});

export const ArcadeExtensionInstallStatesSchema = z.record(identifier, z.object({
  extensionKey: z.string().min(3).max(260),
  version: z.string().min(1).max(128),
  manifestDigest: digest,
  grantRevision: z.number().int().positive(),
  status: z.enum(["installed", "disabled", "incompatible", "quarantined"]),
  installedAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
  failureCount: z.number().int().nonnegative().max(1000),
  lastError: z.string().max(1024).optional(),
}).strict()).superRefine((states, context) => {
  for (const [key, state] of Object.entries(states)) {
    if (key !== state.extensionKey)
      context.addIssue({ code: "custom", message: "Extension installation identity mismatch", path: [key] });
  }
});
